import objectFitImages from 'object-fit-images';

class ObjectFitPolyfill {

	constructor(){
		this.init();
	}

	init() {
		
		document.addEventListener('DOMContentLoaded', (event) => {
			objectFitImages();
	  });
	  
	}

}

export const objectFitPolyfill = new ObjectFitPolyfill();